import { useRecoilValue } from 'recoil';

import { acceptedAccessionTermsAtom } from '../atoms/acceptedAccessionTerms';

export default function useAcceptedAccessionTerms() {
  return useRecoilValue(acceptedAccessionTermsAtom);
}
